<template>
    <div class="col mobilemenu no-gutters">
        <div class="bluebackground">
            <button @click="collapse()" class="close" aria-label="Close"><span class="closebtn" aria-hidden="true">close</span><!-- End back --></button>
            <div class="clear"></div><!-- End clear -->
            <div class="navigation">
                <div class="shop card w-100 card-body">
                    <div class="col-lg-3 categorysubmenu">
                        <div class="col-lg" v-for="(category, i) in categories" :key="i">
                            <menu-category :category="category"></menu-category>
                        </div>
                    </div>
                     <a href="https://r1.rent/548a">
                 <button class="holidaydeals-banner"></button>
                   </a>
                </div>
                
            </div>
            
           
                
                
        </div><!-- End navigation -->
        
        
        <ul class="bottommobilemenu">
                <li>
                   <a href="/learnmore">Learn More</a>
                </li>
                
                <li><a href="https://payments.shoprentone.com/" target="_blank">Pay Now</a></li>
                <li><a href="/locations">Find a Store</a></li> 
                <li><a href="https://jobs.shoprentone.com/" target="_blank">Careers</a></li>
                <li class="space"><a href="/contact-us">Contact</a></li>
        </ul>
    </div>
</template>

<script>
    import MenuCategory from './MenuCategory.vue';

    export default {
        props: ['categories'],
        components: {MenuCategory},
        data(){
            return {
                showShop: false,
                showCompany: false
            }
        },

        methods: {
          collapse: () => {
            $('#navbarMobileMenu').collapse('hide')
          }
        }
    }
</script>
